import { List, PopoverProps, Space } from 'antd'
import { IFIReportType, alphabeticalSort } from 'shared'

export function useImportRulesHelpText(): Pick<
  PopoverProps,
  'title' | 'content'
> {
  return {
    title: <div style={{ textAlign: 'center' }}>Import Rules</div>,
    content: (
      <Space
        direction="vertical"
        size="small"
        style={{ overflow: 'auto', maxHeight: 300 }}
      >
        {IFIReportType.sort(alphabeticalSort('type')).map(
          ({ type, importRules }) => (
            <List
              header={type}
              locale={{ emptyText: 'This report is not imported yet' }}
              size="small"
              split={false}
              dataSource={importRules}
              renderItem={(rule) => <List.Item>{rule}</List.Item>}
            />
          )
        )}
      </Space>
    ),
  }
}
